<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-04-21_fysiosari";
    let title = "FysioSari on nyt Dynamosalilla!";
    let firstPara = "Olen Sari Pihlajaniemi. Ammatiltani olen fysioterapeutti ja koulutettu hieroja. Löydät minut jatkossa yhtenä\n" +
        "                            päivänä viikosta Dynamosalilta.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                style="background-image: url('/svelte-site/img/massage/fysiosari_medium.jpg')"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>
{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">21.04.2024</div>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <p>Olen Sari Pihlajaniemi. Ammatiltani olen fysioterapeutti ja koulutettu hieroja. Toimin
                        tällä hetkellä yrittäjänä Limingassa Lakeustalolla, mutta jatkossa minut löytää myös yhtenä
                        päivänä viikosta Dynamosalilta.</p>

                    <p>Voit käydä tutustumassa palveluihini tarkemmin:
                        <a href="https://www.fysiosari.net" target="_blank">täältä</a>, löydät minut myös Instagramista
                        ja
                        Facebookista
                        FysioSari-nimellä.</p>

                    <p>Nähdään kevään aikana Dynamolla!<br>
                        Terveisin,<br>
                        Sari Pihlajaniemi, FysioSari<br></p>
                </div>
                <div class="col-xs-12 col-md-6">
                    <img style="width: 300px;" src='/svelte-site/img/massage/fysiosari_medium.jpg' class="img" alt="">
                </div>
            </div>
        </article>
    </div>
{/if}

<style>


    .yhteistyossa {
        clear: both;
        font-size: 85%;
    }

    .yhteistyossa img {
        float: left;
        height: 90px;
        margin: 8px 32px 8px 0;
    }

    @media all and (max-width: 900px) {
        .yhteistyossa img {
            height: 80px;
        }
    }

</style>
